const topKElementsProblems = [
  {
      title: "Kth Largest Element in an Array",
      url: "https://leetcode.com/problems/kth-largest-element-in-an-array/"
    },
    {
      title: "Find K Pairs with Smallest Sums",
      url: "https://leetcode.com/problems/find-k-pairs-with-smallest-sums/"
    },
    {
      title: "Top K Frequent Elements",
      url: "https://leetcode.com/problems/top-k-frequent-elements/"
    },
    {
      title: "Sliding Window Maximum",
      url: "https://leetcode.com/problems/sliding-window-maximum/"
    }
];
export default topKElementsProblems;